import { gql } from "@apollo/client";

export const GET_SUBSCRIPTION_TERMINATE_AMOUNT = gql`
  query getSubscriptionEarlyTerminateAmount($bookingId: String!, $newEndDate: String!) {
    getSubscriptionEarlyTerminateAmount(bookingId: $bookingId, newEndDate: $newEndDate)
  }
`;
